import { PaymentSettings } from "booking_app/types/payment-settings";

export class PaymentStylingSettings {
  public paymentSettings: PaymentSettings;
  constructor(
  ) {
    this.setupPaymentStyling();
  }

  setupPaymentStyling(): void {
    // Default base style
    this.paymentSettings = {
      stripe: {
        base: {
          "color": "#002F6B",
          "fontSize": "16px",
          "fontWeight": "400",
          "fontSmoothing": "antialiased",
          "::placeholder": {
            color: "#4C6D97",
            fontSmoothing: "antialiased",
            fontSize: "14px",
          },
        },
        invalid: {
          color: "#002F6B",
          fontSize: "16px",
        },
      },
    };
  }
}
angular.module("BookingApp").service("PaymentStylingSettings", PaymentStylingSettings);
